export const SIGNUP_FORM_MODEL = 'rrSignupForms';
export const LOGIN_FORM_MODEL = 'loginForm';
export const FORGOT_PWD_FORM_MODEL = 'forgotPwdForm';
export const RESET_PWD_FORM_MODEL = 'resetPwdForm';
export const TRANSFER_FORM_MODEL = 'transferFundsForm';
export const OFFER_ORDER_FORM_MODEL = 'offerOrderForm';
export const EXTERNAL_OFFER_ORDER_FORM_MODEL = 'externalOfferOrderForm';
export const MANAGE_ACCOUNT_FORM_MODEL = 'manageAccountForm';
export const SUITABILITY_FORM_MODEL = 'suitabilityForm';
export const TRADE_SECURITY_FORM_MODEL = 'tradeSecurityForm';
export const CHANGE_CREDENTIALS_FORM = 'changeCredentialsForm';
export const UPLOAD_VERIFY_DOCS_FORM = 'uploadVerifyDocsForm';
export const UPLOAD_DRIVER_LICENSE_FORM = 'uploadDriverLicenseForm';
export const INDICATE_INTEREST_FORM_MODEL = 'indicateInterestForm';



// WEBPACK FOOTER //
// ./src/form_models.js